let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bPVgw")).then(() => parcelRequire('2ePcG'));